import { defineStore } from "pinia";
import axios from "axios";
import { useToast } from 'vue-toastification';
const toast = useToast();


export const useLoginStore = defineStore("login", {
    state: () => {
        return {
            loadings: false
        };
    },

    getters: {
        loading: (state) => state.loadings,
    },

    actions: {
        post(data) {
            this.loadings = true;
            const config = {
                method: "post",
                url: useRuntimeConfig().public.apiBase + 'login',
                data: {
                    ...data
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        localStorage.refresh = res.data.data.refresh
                        localStorage.token = res.data.data.token
                        toast.success(res.data.msg);
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        toast.error(error.response.data.msg);
                        reject(error.response.data.msg);
                    });
            });
        },
        confirmEmail(code) {
            const config = {
                method: "post",
                url: useRuntimeConfig().public.apiBase + 'login/confirm',
                headers: {
                    usertoken: localStorage.token,
                },
                data: {
                    code: code
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        toast.success(res.data.msg);
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        toast.error(error.response.data.msg);
                        reject(error.response.data);
                    });
            });
        },
        reSendCode() {
            const config = {
                method: "post",
                url: useRuntimeConfig().public.apiBase + 'login/againcode',
                headers: {
                    usertoken: localStorage.token,
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        toast.success(res.data.msg);
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        toast.error(error.response.data.msg);
                        reject(error.response.data);
                    });
            });
        }
    },
});